import React from 'react'
const MAX_OFFSET = 366

class OffsetInput extends React.Component {
  handleChange (e) {
    const value = e.target.value
    const regex = (this.props.allowNegative ? /^-?\d*$/ : /^\d*$/)
    if (regex.test(value)) {
      const offset = Number(value)
      if (isNaN(offset)) { this.props.onChange(value) }
      if (!isNaN(offset) && Math.abs(offset) <= MAX_OFFSET) {
        this.props.onChange(value)
      }
    }
  }
  render () {
    return (
      <input
        disabled={this.props.disabled}
        className='form-control'
        type='text'
        value={this.props.value}
        onChange={e => this.handleChange(e)} />
    )
  }
}

export default OffsetInput



// WEBPACK FOOTER //
// ./src/components/Editors/OffsetInput.js